import { FeedstockKey, MetricKey } from '../types/emission-factor.constants';
import { useCallback } from 'react';
import { useEmissionFactorRecord } from './useEmissionFactorRecord';
import { useHierarchyNavigation } from './useHierarchyNavigation';

export function useEmissionFactorModal(materialGradeId?: string) {
   const hierarchy = useHierarchyNavigation(materialGradeId);
   const { setFormState, cachedResponsesRef, formState } = hierarchy;

   const onChangesFlushed = useCallback(() => {
      setFormState((prev) => ({ ...prev, hasChanges: false }));
   }, [setFormState]);

   const record = useEmissionFactorRecord(formState.selectedGrade, cachedResponsesRef, onChangesFlushed);
   const { updateYearlyValue: recordUpdateYearlyValue } = record;

   const updateYearlyValue = useCallback(
      (year: number, feedstock: FeedstockKey, field: MetricKey, value: number | null) => {
         recordUpdateYearlyValue(year, feedstock, field, value);
         setFormState((prev) => ({ ...prev, hasChanges: true }));
      },
      [recordUpdateYearlyValue, setFormState]
   );

   return {
      ...hierarchy,
      ...record,
      updateYearlyValue,
      error: hierarchy.error || record.saveError,
   };
}
